import { render } from "./ToDoItemEditForm.vue?vue&type=template&id=fb76d5ac&scoped=true"
import script from "./ToDoItemEditForm.vue?vue&type=script&lang=js"
export * from "./ToDoItemEditForm.vue?vue&type=script&lang=js"

import "./ToDoItemEditForm.vue?vue&type=style&index=0&id=fb76d5ac&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/derbyweb.dev/todo.derbyweb.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb76d5ac"]])

export default __exports__